/**
 * Kosakata & aturan bersama layar Claim MDR.
 *
 * KENAPA BERKAS INI ADA
 * ---------------------
 * `MDR_BASE`, `MODUL_MDR`, dan `nilaiMdr` tadinya hidup di `ClaimMdr.jsx` dan
 * diimpor balik oleh modal-modalnya — impor SIRKULER (halaman -> modal ->
 * halaman). Itu berjalan selama nilainya hanya dipakai saat render, tapi akan
 * memberi `undefined` begitu ada yang memakainya saat modul dievaluasi, dan
 * galatnya muncul jauh dari sebabnya. Dipisah sebelum berkas ketiga
 * (`ClaimMdrNotaPrint.jsx`) ikut masuk ke lingkaran itu.
 */

export const MDR_BASE = "/claim-mdr";
export const MODUL_MDR = "finance_claim_mdr";

// Status "Siap Claim" = satu-satunya yang boleh diekspor DAN ditandai
// (`ekspor.baris_ekspor`, `proses.tandai_sudah_claim`). Kodenya dipakai
// sebagai LOGIKA; LABELNYA selalu dari `/meta` supaya tidak berpisah jalan
// dengan `aturan.LABEL_STATUS`.
export const SIAP_CLAIM = "eligible";
export const SUDAH_CLAIM = "sudah_claim";

/** Nilai yang DITAMPILKAN harus sama dengan yang DIEKSPOR.
 *
 * `ekspor.buat_xlsx` memakai `h = b.get("hasil") or b` — hasil pencocokan
 * lebih dulu, baris berkas sebagai cadangan. Layar mengikuti aturan yang sama
 * lewat satu penolong: menampilkan angka berkas sementara yang dikirim ke
 * vendor angka hasil pencocokan adalah cara paling halus membuat Finance
 * menyetujui sesuatu yang tidak ia lihat.
 *
 * Nol TIDAK dianggap kosong (DP boleh 0 saat SRP = Nominal, butir 16); yang
 * dianggap kosong hanya undefined/null/"".
 */
export function nilaiMdr(row, kunci) {
  const h = row?.hasil;
  const dariHasil = h && Object.keys(h).length ? h[kunci] : undefined;
  return dariHasil === undefined || dariHasil === null || dariHasil === "" ? row?.[kunci] : dariHasil;
}
